// Chakra imports
import { Box, Grid, useToast } from "@chakra-ui/react";

// Custom components
import Banner from "views/admin/profile/components/Banner";
import General from "views/admin/profile/components/General";
import Notifications from "views/admin/profile/components/Notifications";
import Projects from "views/admin/profile/components/Projects";
import Upload from "views/admin/profile/components/Upload";
// Assets
import { apiurl } from "APIURL";
import banner from "assets/img/auth/banner.png";
import avatar from "assets/img/avatars/avatar4.png";
import axios from "axios";
import React from "react";
import { useJwt } from "react-jwt";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getProfileData, setProfile } from "redux/slices/userSlice";

export default function Overview() {
  const toast = useToast();
  const history = useHistory();
  /*const firebaseMessaging = useFirebaseMessaging({
		onMessage: (message) => {
		  console.log(`Received foreground message`, message)
		  
			toast(
				{
					title: message?.notification?.title || message?.data?.title
				}
			)
		  
		}
	  })
	
	  useEffect(() => {
		firebaseMessaging.init()
	  }, [])*/
  const token = localStorage.getItem("token");
  const profile = useAppSelector(getProfileData);
  const user = JSON.parse(localStorage.getItem("user"));
  const dispatch = useAppDispatch();
  const { decodedToken, isExpired } = useJwt(user.access_token);
  if (isExpired === true) {
    toast({
      title: "Votre session est expirée",
      description: "Veillez réconnecter !",
      duration: 3000,
      status: "warning",
    });
    setTimeout(() => history.push("/auth/signin"), 3200);
  }
  console.log(user);

  React.useEffect(() => {
    const getProfile = async () => {
      const userId = localStorage.getItem("userId");
      const res = await axios.get(`${apiurl}/user/profile/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(
        setProfile({
          birthdate: new Date(res.data.profile.birthdate),
          ...res.data.profile,
          ...res.data.user,
        })
      );
    };

    getProfile();
  }, [user.id]);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      {/* Main Fields */}
      <Grid
        templateColumns={{
          base: "1fr",
          lg: "1.34fr 1fr 1.62fr",
        }}
        templateRows={{
          base: "repeat(3, 1fr)",
          lg: "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}
      >
        <Banner
          gridArea="1 / 1 / 2 / 2"
          banner={banner}
          avatar={profile.image}
          name={profile.name + " " + profile.surname}
          email={profile.email}
          signedFormations={profile.level}
          rating={profile.rating}
          level={profile.level}
        />
        <Upload
          gridArea={{
            base: "3 / 1 / 4 / 2",
            lg: "1 / 3 / 2 / 4",
          }}
          minH={{ base: "auto", lg: "420px", "2xl": "365px" }}
          pe="20px"
          pb={{ base: "100px", lg: "20px" }}
        />
        {/*<Storage gridArea={{ base: '2 / 1 / 3 / 2', lg: '1 / 2 / 2 / 3' }} used={25.6} total={50} />
				<Upload
					gridArea={{
						base: '3 / 1 / 4 / 2',
						lg: '1 / 3 / 2 / 4'
					}}
					minH={{ base: 'auto', lg: '420px', '2xl': '365px' }}
					pe='20px'
					pb={{ base: '100px', lg: '20px' }}
				/>*/}
      </Grid>
      <Grid
        mb="20px"
        templateColumns={{
          base: "1fr",
          lg: "repeat(2, 1fr)",
          "2xl": "1.34fr 1.62fr 1fr",
        }}
        templateRows={{
          base: "1fr",
          lg: "repeat(2, 1fr)",
          "2xl": "1fr",
        }}
        gap={{ base: "20px", xl: "20px" }}
      >
        <General />
        <Projects
          banner={banner}
          avatar={avatar}
          name="Ala"
          job="Product Designer"
          posts="17"
          followers="9.7k"
          following="274"
          gridArea={{ base: "2 / 1 / 3 / 2", lg: "1 / 2 / 2 / 3" }}
          minH="365px"
          pe="20px"
        />

        <Notifications
          used={25.6}
          total={50}
          gridArea={{
            base: "3 / 1 / 4 / 2",
            lg: "2 / 1 / 3 / 3",
            "2xl": "1 / 3 / 2 / 4",
          }}
        />
      </Grid>
    </Box>
  );
}
